import styled, { css } from 'styled-components';
import Card from '~/components/atom/Card';

import Icon from '~/components/atom/Icon';

export const OfficeIcon = styled(Icon)<{}>`
  margin-right: 0.5em;

  ${({ theme }) => css`
    color: ${theme.color('primary', 'light')};
    font-size: ${theme.fontSize('m')};
  `};
`;

export const OfficeCounter = styled.div<{}>`
  display: flex;
  padding-left: 1em;
  white-space: nowrap;
`;

export const ButtonContainer = styled.div<{}>`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  justify-self: end;
  min-width: 0;
  max-width: 100%;

  ${({ theme }) => css`
    gap: ${theme.space('m')};
  `}

  & > button {
    align-self: center;
  }
`;

export const CardElement = styled(Card)<{
  $isPending?: boolean;
}>(
  ({ $isPending, theme }) => css`
    display: grid;
    grid-template-columns:
      minmax(0, 20%)
      minmax(0, 10%)
      minmax(0, 20%)
      minmax(0, 10%)
      minmax(0, 1fr);
    align-items: center;
    cursor: ${$isPending ? 'default' : 'pointer'};
    column-gap: 1em;

    /* Allow truncation inside grid cells */
    & > * {
      min-width: 0;
    }

    ${theme.mq.lessThan('tabletLandscape')`
      grid-template-columns: minmax(0, 1fr) auto;
    `}
  `,
);

export const UserEmailElement = styled.div<{}>`
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${({ theme }) => css`
    padding-left: ${theme.space('l')};

    ${theme.mq.lessThan('tabletLandscape')`
      display: none;
    `}
  `}
`;

export const UserPhoneElement = styled.div<{}>`
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${({ theme }) => css`
    ${theme.mq.lessThan('tabletLandscape')`
      display: none;
    `}
  `}
`;

export const EnvelopeIcon = styled(Icon)<{}>`
  margin-right: 1em;

  ${({ theme }) => css`
    color: ${theme.color('accent')};
  `};
`;

export const UserNameContainer = styled.div<{}>`
  display: flex;
  align-items: center;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;

  & > span {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const UserRoleElement = styled.div<{}>`
  width: 140px;
  min-width: 140px;
  max-width: 100%;
`;
